:host {
  visibility: hidden;
}

.tooltip {
  background-color: var(--color-white);
  z-index: 5001;
}

.close {
  display: none
}

@include breakpointMax("lg") {
  :host {
    width: 100%;
    height: 100%;
    background-color: var(--color-white);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .close {
    display: block;
    font-family: var(--primary-font);
    color: var(--color-nero);
    font-size: 28px;
    font-weight: bold;
    margin: 0;
    margin-bottom: 10px;
    float:right;
  }
}

@include breakpointMin("lg") {
  .tooltip {
    width: fit-content;
    height: fit-content;
    position: absolute;
    padding: 20px;
    filter: drop-shadow(0 0 6px #bbb);

    .img-container {
      width: 200px;
      height: 100%;
    }

    &::after {
      content: "";
      position: absolute;
      border-style: solid;

      z-index: 5000;
      top: 50%;

      transform: translateY(-50%);
    }

    &.right {
      transform: translate(60px,calc(-50% + 10px));

      &::after {
        right: 100%;
        border-width: 10px 10px 10px 0;
        border-color: transparent var(--color-white) transparent transparent;
      }
    }

    &.left {
      transform: translate(-240px,calc(-50% + 10px));

      &::after {
        left: 100%;
        border-width: 10px 0px 10px 10px;
        border-color: transparent transparent transparent var(--color-white);
      }
    }
  }
}
